import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../Assets/Images/logo.png";
import IconA from "../../Assets/sidebar/icon1.png";
// import { logoutUser } from "../../Redux/Slice/AuthSlice";

import { updateAuth } from "../../Redux/AuthSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
// import { fetchDashboardData } from "../../Redux/Slice/DashboardSlice";
import { API } from "../../Utility/API";

import {
  ContractAddress,
  ContractAddress_ABI,
  ContractAddressToken,
  ContractAddressToken_Abi,
} from "../../Connectivity/Contract";
import { loadWeb3 } from "../../Connectivity/apiBnb";
// import Loader from "../Loader/Loader";
import SidebarBOT from "../Sidebar/SidebarBOT";
import { Spinner } from "react-bootstrap";
export default function Deposit() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userId, jwtToken } = useSelector((state) => state.Auth);
  const [UsdtAddress, setUsdtAddress] = useState(null);

  const [depositAmount, setDepositAmount] = useState("");
  const [TokenAmount, setTokenAmount] = useState(0);
  const [depositUsdt, setDepositUsdt] = useState("");
  const [selectedAmount, setSelectedAmount] = useState("");
  let [spiner, setspiner] = useState(false);

  const [connected, setconnected] = useState("Wallet is locked");
  const [USDTBalance, setUSDTBalance] = useState(0);
  const [dashData, setdashData] = useState([]);
  const [dash, setdataArray] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Loader component
  const Loader = () => (
    <div className="loader text-center">
      <Spinner animation="border" variant="primary" />
      <p>Loading...</p>
    </div>
  );
  // Toggle sidebar function
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const walletConnected = async () => {
    try {
      let acc = await loadWeb3();

      if (acc == "No Wallet") {
        // toast.error("No Wallet");
        setconnected("Wallet is locked");
      } else if (acc == "Wrong Network") {
        toast.error(" Wrong Network Please Connect BSC Network");
        alert(" Wrong Network Please Connect BSC Network");
        setconnected("Wrong Network");
      } else {
        // setaddress(acc)
        setconnected("Wallet is Connected");
      }
    } catch (e) {
      console.log("Error While WalletConnect", e);
    }
  };

  const USDTBalanceinAddress = async () => {
    try {
      let acc = await loadWeb3();

      let contract = await new window.web3.eth.Contract(
        ContractAddressToken_Abi,
        ContractAddressToken
      );

      let result = await contract.methods.balanceOf(acc.toString()).call();

      result = parseFloat(result) / 10 ** 18;
      setUSDTBalance(result.toFixed(2));
    } catch (error) {
      console.log(error);
    }
  };

  const Dashboard_API = async () => {
    console.log("inDashboard_API", userId);
    try {
      let responce = await API?.post(
        "userdashboard",
        {
          uid: userId,
          type: 2,
        },
        {
          headers: {
            Authorization: `${jwtToken}`,
          },
        }
      );
      responce = responce.data.data[0];
      setdataArray(responce);
      setUsdtAddress(responce.accountaddress);

      // setdataArray(responce);
    } catch (e) {
      //console.log("userDetails error", e);
      // console.log("userDetails error", e.response.data);
    }
  };

  const handleAmountClick = (amount) => {
    setDepositAmount(amount);
    if (amount > 0) {
      setTokenAmount(amount * dashData.RateToken);
    }
  };

  const DepositAmountByContract = async () => {
    // debugger;
    // console.log("UsdtAddress",UsdtAddress);

    setspiner(true);
    let acc = await loadWeb3();
    if (acc == "No Wallet") {
      toast.error("No Wallet");
      setspiner(false);
    } else if (acc == "Wrong Network") {
      //toast.error("Wrong Network Please Connect BSC Scan Network");
      console.log("Wrong Network Please Connect Polygon Scan Network");
      setspiner(false);
    } else if (UsdtAddress == null || UsdtAddress == "") {
      //toast.error("Please Update Address In profile");
      alert("Please Update Address In profile");
      setspiner(false);
    } else {
      // console.log("usdt", UsdtAddress);
      // console.log(acc.toUpperCase());

      if (UsdtAddress.toUpperCase() == acc.toUpperCase()) {
        if (depositAmount != "") {
          if (parseFloat(USDTBalance) < parseFloat(depositAmount)) {
            // toast.error(
            //   `Insufficient USDT Balance (Balance : ${USDTBalance}, Deposit : ${depositAmount})`
            // );
            alert(
              `Insufficient USDT Balance (Balance : ${USDTBalance}, Deposit : ${depositAmount})`
            );
            setspiner(false);
          } else {
            let amountValue = window.web3.utils.toWei(depositAmount, "ether");
            const gasPrice = await window.web3.eth.getGasPrice();
            const approveBlock = window.web3.eth.getBlock("latest");

            try {
              let contract_Main = await new window.web3.eth.Contract(
                ContractAddress_ABI,
                ContractAddress
              );
              let contract_USDT = await new window.web3.eth.Contract(
                ContractAddressToken_Abi,
                ContractAddressToken
              );

              let approveCall = await contract_USDT.methods
                .approve(ContractAddress, amountValue)
                .send({
                  from: acc,
                  gasLimit: approveBlock.gasLimit,
                  gasPrice: await window.web3.eth.getGasPrice(),
                });
              // toast.success("Approved Succesful");
              alert("Approved Succesful");
              let sellCall = await contract_Main.methods
                .deposit(amountValue)
                .send({
                  from: acc,
                  gasLimit: approveBlock.gasLimit,
                  gasPrice: await window.web3.eth.getGasPrice(),
                });
              console.log("sellCall", sellCall);
              let res = await API.post(
                "FunAddByContract",
                {
                  uid: userId,
                  addreslist: acc,
                  usd: depositAmount,
                  txn: sellCall.transactionHash,
                  CoinType: "USDT",
                },
                {
                  headers: {
                    Authorization: `${jwtToken}`,
                    "Content-Type": "application/json",
                  },
                }
              );

              if (res.data.success == true) {
                //toast.success("Deposit Successful !!");
                alert("Deposit Successful !!");
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
                setspiner(false);
              }
            } catch (err) {
              console.log("error while calling fuction sell", err);
            }
          }
        } else {
          // toast.error("Please Enter Amout First");
          alert("Please Enter Amount First");
          setspiner(false);
        }
      } else {
        toast.error("Invalid Wallet address");
        setspiner(false);
      }
    }

    // setloader(false)
  };

  useEffect(() => {
    setInterval(() => {
      walletConnected();
      USDTBalanceinAddress();
    }, 5000);
  }, []);

  useEffect(() => {
    Dashboard_API();
  }, []);

  return (
    <>
      <div className="container-fluid NewDashboard">
        <div className="row">
          <div
            className={` ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
          >
            <SidebarBOT />
          </div>
          <div className="col-lg-2 px-0 order-2">
            <div className="sidebarLeft px-3 position-relative">
              <div className="leftisidelogo">
                <img className="h-100 w-100" src={logo} alt="" />
              </div>
              <ul className="itemssidebar">
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    MAGIC Investment
                  </Link>
                  {dash?.BOTpackage}
                </li>
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    FOREX Investment
                  </Link>
                  {dash?.Forexpackage}
                </li>
                <li>
                  <Link
                    to=""
                    className="Anker w-100"
                    id="txtchangevalue"
                    value="Withdrawal"
                    // onClick={() => OnHandleWithdrawalLink()}
                  >
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    Total Income
                  </Link>
                  ${dash.TotalIncome}
                </li>
                <li>
                  <Link
                    to=""
                    className="Anker w-100"
                    id="txtchangevalue"
                    value="Withdrawal"
                    // onClick={() => OnHandleWithdrawalLink()}
                  >
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    Withdrawal Amount
                  </Link>
                  ${dash.WithDrawal_Amount}
                </li>
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    Net Balance
                  </Link>{" "}
                  ${dash?.Net_Balance}
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-10 px-0 order-lg-2 order-1">
            <div className="contentside">
              <div className="row mx-0">
                <div className="col-12 px-0">
                  <header className="header ps-0">
                    <div className="hdleft d-flex align-items-center">
                      <div className="namelogo ps-3"></div>
                    </div>
                    <div className="rightside">
                      <div className="dropdown dropdow2 d-none d-md-block">
                        <Link
                          className="btn btnsecondary dropdown-toggle"
                          to=""
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span className="text1">
                            <p className="mb-1">ID Number</p>
                            <p className="mb-0 fw-bold text-start">{userId} </p>
                          </span>
                          <span className="icon">
                            <div className="name">
                              <img className="w-100 h-100" src={logo} alt="" />
                            </div>
                          </span>
                        </Link>

                        <ul className="dropdown-menu p-2">
                          <li className="text-white walltadd">
                            {dash?.f_name}
                          </li>
                        </ul>
                      </div>
                      <div className="dropdown dropdow2 d-block d-md-none">
                        <Link
                          className="btn btnsecondary dropdown-toggle"
                          to=""
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span className="icon">
                            <div className="name">
                              <img className="w-100 h-100" src={logo} alt="" />
                            </div>
                          </span>
                        </Link>

                        <ul className="dropdown-menu">
                          <li>
                            <Link className="dropdown-item" to="#">
                              Id Number <span>{userId}</span>
                            </Link>
                          </li>
                          <li className="text-white walltadd">
                            {dash?.f_name}
                          </li>
                        </ul>
                      </div>
                      <a href="/DashboardFIX">
                        <button className="btn headerbtn">FIX PLAN</button>
                      </a>
                      <a href="/DashboardBOT">
                        <button className="btn headerbtn">MAGIC PLAN</button>
                      </a>
                      <button
                        className="btn border-0 togglebtn"
                        id="togglebtn"
                        onClick={toggleSidebar}
                      >
                        <i
                          className={`fas fa-bars text-white ${
                            isSidebarOpen ? "" : "collapsed"
                          }`}
                        ></i>
                      </button>
                    </div>
                  </header>
                </div>
              </div>
              <div className="row mx-0">
                <div className="col-lg-3"></div>
                <div className="col-lg-6">
                  <div className="card leftsidecardpoint">
                    <div className="card-body">
                      <div className="card-heading">Add Fund (USDT)</div>
                      <div className="" role="document">
                        <div className="modal-content10">
                          <div className="" style={{ paddingBottom: 10 }}>
                            <div className="avlbal">
                              <div className="Model_text_inner activation_Item">
                                <div className="rate_item text-white">
                                  <span className="text-black fs-4">
                                    {" "}
                                    USDT Balance : {USDTBalance} USDT
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="activation_modal">
                            <div className="popup_net">
                              <div className="addNum">
                                <div className="trxnumber text-black fs-4">
                                  <span
                                    className="text-black"
                                    style={{ marginLeft: 10 }}
                                  >
                                    Deposit Amount
                                  </span>
                                  <br />
                                  <input
                                    type="text"
                                    readOnly=""
                                    value={depositAmount}
                                    onChange={(e) =>
                                      handleAmountClick(e.target.value)
                                    }
                                    id="txtamount2"
                                    className="form5"
                                    defaultValue={0}
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-12">
                                  <div
                                    className="trxnumber"
                                    style={{ textAlign: "center" }}
                                  >
                                    <button
                                      className="viewalls"
                                      onClick={(e) =>
                                        DepositAmountByContract(e.target.value)
                                      }
                                    >
                                      Deposit Now
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
